import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { getBlogs, deleteBlog, blogDetail, updateBlog, showToast } from "../Utils/utils";
import { buildBlogFormData, todayStr, formatPublishedDate } from "../../components/Blog/blogUtils";
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import Loaderspinner from "../../components/Loader";
import { Tooltip } from 'react-tooltip'
import SweetAlert from "react-bootstrap-sweetalert";

const LIMIT = 10;

const Blogs = () => {
    const [showSidebar, setShowSidebar] = useState(false);
    const [loading, setLoading] = useState(false)
    const [blogList, setBlogList] = useState([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [blogId, setBlogId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);

    const handleSidebar = () => {
        setShowSidebar(!showSidebar);
    };

    const handleSidebarClose = () => {
        setShowSidebar(false);
    };

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search, status]);

    const fetchList = async () => {
        try {
            setLoading(true);

            const response = await getBlogs({ search, limit: LIMIT, page: page + 1, status });

            if (response?.status == 200) {
                const rows = response?.data?.rows || (Array.isArray(response?.data) ? response.data : []);
                const count = response?.data?.count;
                setBlogList(rows);
                if (typeof count === "number" && count > LIMIT) {
                    setTotalPages(Math.ceil(count / LIMIT));
                } else if (rows.length < LIMIT) {
                    setTotalPages(page + 1);
                } else {
                    setTotalPages(page + 2);
                }
            } else {
                console.log("cannot fetch blogs", response)
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            var res = await deleteBlog(blogId)
            if (res.status == 200) {
                showToast("Deleted successfully", "success");
                fetchList();
            }
        } catch (error) {
            showToast(error?.message || "Delete failed", "error");
        }
        setShowAlert(false);
    };

    const toggleStatus = async (blog) => {
        const next = blog.status === "published" ? "draft" : "published";
        try {
            setLoading(true);
            const detail = await blogDetail(blog.id);
            if (detail?.status != 200) {
                showToast(detail?.message || "Could not load post", "error");
                return;
            }
            const d = detail.data;
            let tags = d.tags;
            if (typeof tags === "string") {
                try { tags = JSON.parse(tags); } catch (e) { tags = []; }
            }
            const formData = buildBlogFormData({
                title: d.title,
                slug: d.slug,
                kicker: d.kicker,
                description: d.description,
                body_html: d.body_html,
                author: d.author,
                tags: Array.isArray(tags) ? tags : [],
                status: next,
                published_at: d.published_at ? String(d.published_at).slice(0, 10) : (next === "published" ? todayStr() : ""),
            }, blog.id);
            const res = await updateBlog({ formData });
            if (res?.status == 200) {
                showToast(next === "published" ? "Post published" : "Post moved to draft", "success");
                fetchList();
            } else {
                showToast(res?.message || "Update failed", "error");
            }
        } catch (error) {
            showToast(error?.message || "Update failed", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loaderspinner />}
            <div class="g-sidenav-show  bg-gray-100">
                <div id="wrapper">
                    <Leftbar showSidebar={showSidebar}
                        handleSidebarClose={handleSidebarClose} />
                    <main className="main-content border-radius-lg">
                        <Topbar handleSidebar={handleSidebar} />

                        <div className="header header-bg pb-6">
                            <div className="container-fluid">
                                <div className="header-body">
                                    <div className="row align-items-center py-4">
                                        <div className="col-lg-6 col-7">
                                            <nav
                                                aria-label="breadcrumb"
                                                className="d-none d-md-inline-block ml-md-4"
                                            >
                                                <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                                                    <li className="breadcrumb-item">
                                                        <Link to="/dashboard">
                                                            <i className="fas fa-home" />
                                                        </Link>
                                                    </li>
                                                    <li className="breadcrumb-item mt-2">
                                                        <span className="" style={{ color: "#f6f9fc" }}>Blog</span>
                                                    </li>
                                                </ol>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid mt--6">
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <div className="card-header border-0">
                                            <div className="d-flex justify-content-between">
                                                <div className="row ">
                                                    <h5 className="mb-0 w-auto">Blog Posts</h5>
                                                    <p
                                                        className="w-auto px-0"
                                                        data-tooltip-id="blog-tooltip"
                                                        data-tooltip-content="Manage the blog posts shown on the public website. Drafts are not visible publicly until published."
                                                        data-tooltip-place="right"
                                                    >
                                                        <i className="fas fa-info-circle" />
                                                    </p>
                                                    <Tooltip id="blog-tooltip" style={{ width: '30%' }} />
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <select
                                                        className="custom-select-dropdown mx-2"
                                                        value={status}
                                                        onChange={(e) => { setPage(0); setStatus(e.target.value); }}
                                                    >
                                                        <option value="">All</option>
                                                        <option value="draft">Draft</option>
                                                        <option value="published">Published</option>
                                                    </select>
                                                    <input
                                                        type="text"
                                                        className="search-input mx-2"
                                                        placeholder="Search"
                                                        value={search}
                                                        onChange={(e) => { setPage(0); setSearch(e.target.value); }}
                                                    />
                                                    <Link to="/add-blog">
                                                        <button className="export-btn"> Create Blog Post </button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Tags</th>
                                                        <th>Status</th>
                                                        <th>Published</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {blogList?.length > 0 ? (
                                                        blogList.map((blog) => (
                                                            <tr key={blog?.id}>
                                                                <td style={{ width: "300px", whiteSpace: "normal" }}>
                                                                    {blog?.title}
                                                                    <div className="text-muted small">/{blog?.slug}</div>
                                                                </td>
                                                                <td style={{ whiteSpace: "normal" }}>
                                                                    {Array.isArray(blog?.tags) && blog.tags.length > 0 ? blog.tags.join(", ") : "-"}
                                                                </td>
                                                                <td>
                                                                    <span className={`badge ${blog?.status === "published" ? "badge-success" : "badge-secondary"}`}>
                                                                        {blog?.status === "published" ? "Published" : "Draft"}
                                                                    </span>
                                                                </td>
                                                                <td>{blog?.published_at ? formatPublishedDate(blog.published_at) : "-"}</td>
                                                                <td style={{ width: "160px" }}>
                                                                    <Link to={`/edit-blog/${blog?.id}`}>
                                                                        <button className="viewproject-btn pull-right mb-1" >
                                                                            <span className="text-white">Edit</span>
                                                                        </button>
                                                                    </Link>
                                                                    <button className="viewproject-btn pull-right mb-1" onClick={() => toggleStatus(blog)}>
                                                                        <span className="text-white">{blog?.status === "published" ? "Unpublish" : "Publish"}</span>
                                                                    </button>
                                                                    <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                                        setBlogId(blog?.id)
                                                                        setShowAlert(true)
                                                                    }} >
                                                                        <span className="text-white">Delete</span>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Row>
                                <Col xs={12}>
                                    <div className='paginate-css'>
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            breakLabel="..."
                                            pageCount={totalPages}
                                            forcePage={page}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={({ selected }) => setPage(selected)}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </main>
                    {showAlert && (
                        <SweetAlert
                            warning
                            showCancel
                            confirmBtnText="Yes, delete it!"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="secondary"
                            title="Are you sure?"
                            onConfirm={handleDelete}
                            onCancel={() => setShowAlert(false)}
                            focusCancelBtn
                        >
                            This action cannot be undone.
                        </SweetAlert>
                    )}
                </div>
            </div>
        </>
    )
}
export default Blogs;
